export const SITES_LAYER_ID = "SITES_LAYER_ID";
